import axios from "axios";

export const getPeriodFinancialSheetTree = (
  id,
  partner,
  partnerZone,
  clients,
  clientGroups,
  collaborators,
  year,
  squads,
  clusters,
  businessUnits,
  sortBy,
  clientTypes,
  clientCRMTypes,
  clientCRMGroup,
  searchWord,
  withBudgetaryBenchmark,
  deletedStatus,
  role,
  isEntity,
  start,
  limit
) => {
  const requestUrl = `/team/financials-period`;
  let params = {
    organizationId: id,
    partner,
    partnerZone: partnerZone,
    clients: clients.map(({ value }) => value),
    clientTypes: JSON.stringify(clientTypes),
    clientCRMTypes: JSON.stringify(clientCRMTypes),
    clientCRMGroup: JSON.stringify(clientCRMGroup),
    clientGroups,
    isEntity: isEntity,
    collaborators: collaborators.map(({ value }) => value),
    period: year,
    squads: squads.map(({ value }) => value),
    clusters: clusters.map(({ value }) => value),
    businessUnits: businessUnits.map(({ value }) => value),
    sortBy: sortBy,
    searchWord: searchWord,
    withBudgetaryBenchmark,
    deletedStatus,
    role,
    start,
    limit
  };

  return axios.get(requestUrl, {
    params
  });
};

export const exportPeriodFinancialSheet = (
  id,
  clients,
  clientGroups,
  collaborators,
  year,
  squads,
  clusters,
  businessUnits,
  sortBy,
  searchWord,
  withBudgetaryBenchmark,
  clientTypes,
  budgetStatus,
  clientCRMTypes,
  clientCRMGroup,
  collaboratorRole,
  deletedStatus,
  offshoreStatus,
  facturableStatus,
  isEntity
) => {
  const requestUrl = `/team/export/financials-period`;
  let params = {
    organizationId: id,
    clients: clients.map(({ value }) => value),
    clientGroups,
    collaborators: collaborators.map(({ value }) => value),
    period: year,
    squads: squads.map(({ value }) => value),
    clusters: clusters.map(({ value }) => value),
    businessUnits: businessUnits.map(({ value }) => value),
    clientTypes: JSON.stringify(clientTypes),
    clientCRMTypes: JSON.stringify(clientCRMTypes),
    sortBy: sortBy,
    searchWord: searchWord,
    withBudgetaryBenchmark,
    budgetStatus: budgetStatus,
    facturableStatus: facturableStatus,
    groupDescriptions: JSON.stringify(clientCRMGroup),
    collaboratorRole,
    isEntity: isEntity,
    deletedStatus,
    offshoreStatus
  };

  return axios
    .get(requestUrl, {
      params,
      responseType: "blob",
      headers: { Accept: "application/vnd.ms-excel" }
    })
    .then(response => {
      const url = window.URL.createObjectURL(
        new Blob([response.data], { type: response.data.type })
      );
      const link = document.createElement("a");
      link.href = url;
      let date = new Date();
      let day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      let month =
        date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1;
      let minutes =
        date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      let seconds =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      let dateString =
        day +
        "-" +
        month +
        "-" +
        date.getFullYear() +
        " " +
        date.getHours() +
        "-" +
        minutes +
        "-" +
        seconds;
      link.setAttribute(
        "download",
        "PowerTeam Financial-sheet " + dateString + ".xlsx"
      ); //or any other extension
      document.body.appendChild(link);
      link.click();
    });
};

export const importFinancialSheet = ({
  importAttachment,
  data,
  importedYear
}) => {
  const requestUrl = `/team/financial/import`;

  var formData = new FormData();

  formData.append("organizationId", data);

  formData.append("importedYear", importedYear);

  if (importAttachment instanceof File) {
    formData.append("file", importAttachment, importAttachment.name);
  }

  return axios.post(requestUrl, formData);
};



// WEBPACK FOOTER //
// ./src/api/financial-sheet.js